import { render } from "./DailyDemand.vue?vue&type=template&id=4c73be04&scoped=true"
import script from "./DailyDemand.vue?vue&type=script&lang=js"
export * from "./DailyDemand.vue?vue&type=script&lang=js"

import "./DailyDemand.vue?vue&type=style&index=0&id=4c73be04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c73be04"]])

export default __exports__